var React = require('react');

function Archived (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"archived"),React.createElement("g",{"fill":"currentColor","fillRule":"nonzero","key":1},React.createElement("path",{"d":"M6 3h17v10H6V3zm7 3.75a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-3zM6 15h17v10H6V15zm7 3.75a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-3z"}))]);
}

Archived.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = Archived;

Archived.default = Archived;
